import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const inventoryApi = createApi({
  reducerPath: "inventoryApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPurchases: builder.query({
      query: (params) => ({
        url: "inventory/purchase/",
        params,
      }),
    }),
    getPurchaseById: builder.query({
      query: (receiptId) => ({
        url: `inventory/purchase/${receiptId}`,
      }),
    }),
    getUsages: builder.query({
      query: (params) => ({
        url: "inventory/usage/",
        params,
      }),
    }),
    getUsageById: builder.query({
      query: (receiptId) => ({
        url: `inventory/usage/${receiptId}`,
      }),
    }),
    buy: builder.mutation({
      query: (newPurchase) => ({
        url: "inventory/buy",
        method: "POST",
        body: newPurchase,
      }),
    }),
    spendApplication: builder.mutation({
      query: (applicationId) => ({
        url: `inventory/spend/application/${applicationId}`,
        method: "POST",
      }),
    }),
    spendExtraordinary: builder.mutation({
      query: (newUsage) => ({
        url: `inventory/spend/extraordinary`,
        method: "POST",
        body: newUsage,
      }),
    }),
  }),
});

export const {
    useGetPurchasesQuery,
    useGetPurchaseByIdQuery,
    useGetUsagesQuery,
    useGetUsageByIdQuery,
    useBuyMutation,
    useSpendApplicationMutation,
    useSpendExtraordinaryMutation,
} = inventoryApi;